export default "__VITE_ASSET__e6b0a623__"